import { useThemeColor } from '../../../hooks/theme';
import { WithRef } from '../../../types';
import IconBase, { IconProps } from '../IconBase';

export const CastResetZoom = ({
  ref,
  ...props
}: WithRef<SVGSVGElement, IconProps>) => {
  const color = useThemeColor(props.color || 'grey.700');

  return (
    <IconBase ref={ref} {...props} viewBox="0 0 28 28" fill="none">
      <path
        d="M8.7771 10.5C9.70129 8.99996 11.3589 8 13.2501 8C16.1496 8 18.5001 10.3505 18.5001 13.25C18.5001 16.1495 16.1496 18.5 13.2501 18.5C11.3589 18.5 9.70129 17.5 8.7771 16M8.7771 10.5H11.7501M8.7771 10.5V7.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9624 16.9624L19.9999 19.9999"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
};

CastResetZoom.displayName = 'CastResetZoom';
